var React = require('react');

function CalendarIcon (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"path-1-inside-1_1621_14757","fill":"white","key":0},React.createElement("rect",{"y":"3","width":"18","height":"17","rx":"3"})),React.createElement("rect",{"y":"3","width":"18","height":"17","rx":"3","stroke":"#24135F","strokeWidth":"8","mask":"url(#path-1-inside-1_1621_14757)","key":1}),React.createElement("line",{"x1":"5","y1":"3","x2":"5","y2":"2","stroke":"#24135F","strokeWidth":"4","strokeLinecap":"round","key":2}),React.createElement("line",{"x1":"13","y1":"3","x2":"13","y2":"2","stroke":"#24135F","strokeWidth":"4","strokeLinecap":"round","key":3}),React.createElement("line",{"x1":"4","y1":"7","x2":"14","y2":"7","stroke":"#24135F","strokeWidth":"4","strokeLinecap":"round","key":4})]);
}

CalendarIcon.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"};

module.exports = CalendarIcon;

CalendarIcon.default = CalendarIcon;
